import { Swiper } from 'swiper';
import { Navigation, Scrollbar } from 'swiper/modules';
import 'swiper/css';

export const Tpics = {
  init() {
    const sliders = document.querySelectorAll('.p-tpi-slider');
    if (sliders.length) {
      sliders.forEach((sliderEl) => {
        const secEl = sliderEl.closest('.p-tpi-sec');
        const isRight = secEl.classList.contains('-alignR');
        const scroller = sliderEl.querySelector('.p-tpi-slider__scroller');
        const prevEl = sliderEl.querySelector('.p-tpi-slider__prev');
        const nextEl = sliderEl.querySelector('.p-tpi-slider__next');
        new Swiper(sliderEl.querySelector('.swiper'), {
          modules: [Navigation, Scrollbar],
          navigation: {
            prevEl: prevEl,
            nextEl: nextEl,
            disabledClass: 'is-disabled',
          },
          scrollbar: {
            el: scroller,
            dragClass: 'p-tpi-slider__drag',
            draggable: true,
          },
          slidesPerView: 'auto',
          spaceBetween: 25,
          slidesOffsetBefore: isRight ? 0 : 30,
          slidesOffsetAfter: isRight ? 30 : 0,
          breakpoints: {
            768: {
              spaceBetween: 40,
              slidesOffsetBefore: 0,
              slidesOffsetAfter: isRight ? 30 : 0,
            },
          },
        });
      });
    }
  },
};
